var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12894",
    "data-name": "Path 12894",
    d: "M12,21.644a1,1,0,0,1-1-1v-7a1,1,0,0,1,1-1h7a1,1,0,0,1,1,1v7a1,1,0,0,1-1,1Zm1-2h5v-5H13Zm-12,2a1,1,0,0,1-1-1v-7a1,1,0,0,1,1-1H8a1,1,0,0,1,1,1v7a1,1,0,0,1-1,1Zm1-2H7v-5H2Zm10-9a1,1,0,0,1-1-1v-7a1,1,0,0,1,1-1h7a1,1,0,0,1,1,1v7a1,1,0,0,1-1,1Zm1-2h5v-5H13Zm-12,2a1,1,0,0,1-1-1v-7a1,1,0,0,1,1-1H8a1,1,0,0,1,1,1v7a1,1,0,0,1-1,1Zm1-2H7v-5H2Z",
    transform: "translate(0 -1.644)",
    fill: "#600097"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIcon);
export default __webpack_public_path__ + "static/media/dash-icon.0e7dfef2df6e8d4d6b0fb4feb46a369a.svg";
export { ForwardRef as ReactComponent };